// Deps
import { getClient } from "~/modules/wordpress";
import limiter from "~/modules/limiter";
import PageTransition from "~/components/motion/page-transition";

// Components
import Page from "~/components/templates/page";
import ContentContext from "~/context/content";
import Error from "~/pages/_error";

// Data
import frontpageData from "~/data/frontpage.json";

const wp = getClient();

const PagePage = ({ data, error }) => {
    if (!data || error) return <Error />;

    return (
        <PageTransition>
            <ContentContext layout="page" type="page" data={data}>
                <Page page={data} />
            </ContentContext>
        </PageTransition>
    );
};

const typeQueries = {
    "thank-you": () => {
        return wp.thankyou();
    },
    lp: () => {
        return wp.landingpages();
    },
    "embed": () => {
        return wp.embeddedpage();
    },
    page: () => {
        return wp.pages();
    }
};

PagePage.getInitialProps = async ({ asPath, query }) => {
    if (asPath.indexOf(".") !== -1) return;

    const chunks = asPath.split("/");
    let wpQuery = typeQueries.page;

    if (
        chunks.length > 2 &&
        Object.prototype.hasOwnProperty.call(typeQueries, chunks[1])
    ) {
        wpQuery = typeQueries[chunks[1]];
    }

    // Try to grab dynamically exported Wordpress frontpage
    if (query.slug === "/" && frontpageData) {
        query.slug = frontpageData.slug;
    }

    // Default to home page if no slug is found
    let path =
        !query.slug || query.slug === "/"
            ? "ringdna-inside-sales-software" // backup homepage slug
            : query.slug;

    await limiter();

    try {
        const res = await wpQuery()
            .slug(path)
            .embed();

        const page = res && res.length ? res[0] : null;

        if (!page) {
            console.log(`[404]: page, ${asPath}`);
            return { error: 404 };
        }

        return { data: page };
    } catch (e) {
        console.log(`[${e.status}]: page, ${asPath}`);
        return { error: e.status };
    }
};

export default PagePage;
